//Affichage infos coloc sur page mes infos
var statutColoc = $('#statut-coloc');
if (statutColoc.length) {
	statutColoc.on('change', toggleColocInfos);
	statutColoc.trigger('change');
}

function toggleColocInfos() {
	var infosColoc = $('.infos-coloc');
	if (statutColoc.val() !== '' && statutColoc.val() != 1) {
		infosColoc.removeClass('d-none');
	}
	else {
		infosColoc.addClass('d-none');
	}
}


function updateListAgenceByDep() {
    $.ajax({
        type: 'GET',
        url: '/ajax/getAgencesByDept',
        data: {
            numDept: $('#idDepartement').val(),
        },
        dataType: 'json',
    }).done(function(response) {
        if (response.success) {
            var select = $('#idAgence');
            select.empty().append('<option value=""></option>');

            for (var i = 0; i < response.msg.length; i++) {
                var code = response.msg[i].id;
                var text = response.msg[i].raison_sociale;

                select.append('<option value="' + code + '">' + text + '</option>');
            }
        }
    });

}

$('#idDepartement').on('change', null, updateListAgenceByDep);
